var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackedDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000008664"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250842",
    d: "M13.375 16.1211L7.875 17.9544M7.875 17.9544L1 24.8294L5.58333 26.7167M7.875 17.9544L22.5417 24.8294M22.5417 24.8294L16.5833 31.2461L5.58333 26.7167M22.5417 24.8294L28.5 30.3294L39.5 25.4405M22.5417 24.8294L38.5833 17.9544M22.5417 24.8294V44.9961M38.5833 17.9544L45 22.9961L39.5 25.4405M38.5833 17.9544L31.7083 16.1211M22.5417 44.9961L39.5 38.5794V25.4405M22.5417 44.9961L5.58333 38.5794V26.7167",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector 234250843"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 24.8271L7.875 17.9521L22.5417 24.8271L38.5833 17.9521L45 22.9938L39.5 25.4383L28.5 30.3272L22.5417 24.8271L16.5833 31.2438L5.58333 26.7144L1 24.8271Z",
    fill: "#82BD54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5417 24.8271L16.5833 31.2438L5.58333 26.7144L1 24.8271L7.875 17.9521L22.5417 24.8271ZM22.5417 24.8271L28.5 30.3272L39.5 25.4383L45 22.9938L38.5833 17.9521L22.5417 24.8271Z",
    stroke: "#383434",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250841",
    d: "M4.20898 0.995117H15.084C18.95 0.995117 22.084 4.12912 22.084 7.99512V15.6618M22.084 15.6618L25.7507 12.4535M22.084 15.6618L17.5007 12.4535",
    stroke: "#383434",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackedDone);
export default __webpack_public_path__ + "static/media/packed_done.e16f3df45c4ccb7ed70e3e9642ccff19.svg";
export { ForwardRef as ReactComponent };